import React from "react";
import { Group, Rect } from "react-konva";
import { IMondayTaskController } from "../../controller";
import {
  MondayTaskSection,
  MONDAY_TASK_COLUMN_DETAILS_ROW_HEIGHT,
  MONDAY_TASK_WIDTH,
  MONDAY_TASK_DYNAMIC_SECTION_PADDING,
} from "shared/datamodel/monday-task";
import { PADDING } from "../../consts";
import useObservableController from "elements/hooks/use-observable-controller";
import { ColumnDetailRow } from "./column-detail-row";

interface ColumnDetailsProps {
  controller: IMondayTaskController;
}

const ROW_HEIGHT = MONDAY_TASK_COLUMN_DETAILS_ROW_HEIGHT;
const SECTION_PADDING = MONDAY_TASK_DYNAMIC_SECTION_PADDING;

export const ColumnDetails = React.memo(({ controller }: ColumnDetailsProps) => {
  useObservableController(controller, [
    "size-changed",
    "item-changed",
    "board-columns-changed",
    "hidden-columns-changed",
    "pinned-columns-changed",
  ]);

  const y = controller.getSectionY(MondayTaskSection.COLUMN_DETAILS);
  const columns = controller.detailColumns();

  // Don't render if no columns
  if (columns.length === 0) {
    return null;
  }

  return (
    <Group y={y}>
      <Rect width={MONDAY_TASK_WIDTH} height={1} fill="#EBEDF3" />
      {columns.map((column, index) => (
        <ColumnDetailRow key={column.id} column={column} x={PADDING} y={SECTION_PADDING + index * ROW_HEIGHT} />
      ))}
    </Group>
  );
});

ColumnDetails.displayName = "ColumnDetails";
